import React from 'react';
import MenuHeader from './MenuHeader';

function MenuSection({
  title,
  icon,
  children,
  to,
  blank,
  color,
  iconColor,
  onClick,
  onMouseEnter,
  onMouseLeave,
  hasSubItems,
  showAnimatedArrow,
  label,
  isProductLandingLink,
  ...rest
}) {
  return (
    <>
      <MenuHeader
        title={title}
        icon={icon}
        color={color}
        iconColor={iconColor}
        to={to}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        blank={blank}
        hasSubItems={hasSubItems}
        showAnimatedArrow={showAnimatedArrow}
        label={label}
        borderBottom={children ? 'thinDashed' : undefined}
        fontWeight={children ? 'heavy' : undefined}
        {...rest}
      />
      {children}
    </>
  );
}

export default MenuSection;
